import { Link } from 'react-router-dom';
import { StorefrontShell } from '@/components/store/StorefrontShell';
import { Hero } from '@/components/store/Hero';
import { ProductGrid } from '@/components/store/ProductGrid';
import { CollectionStrip } from '@/components/store/CollectionStrip';
import { TrustStrip } from '@/components/store/TrustStrip';
import { copy } from '@/content/copy';
import { storeCopy } from '@/content/store-copy';
import { useProducts } from '@/features/products/queries';

function HomeContent() {
  const { data: products, isPending, isError } = useProducts();

  // The landing page shows the collection in curated order; /shop adds filters.
  const featured = (products ?? []).slice(0, 8);

  return (
    <main>
      <Hero />

      <CollectionStrip products={products ?? []} />

      <section
        id="shop"
        className="bg-[linear-gradient(180deg,#080608,#100b0e_48%,#080608)] px-[clamp(20px,4vw,64px)] py-[76px] pb-[100px] max-[860px]:py-16 max-[860px]:pb-[78px] max-[560px]:px-4 max-[560px]:py-[54px] max-[560px]:pb-[68px]"
      >
        <div className="mx-auto max-w-[1420px]">
          <div className="mb-8 flex items-end justify-between gap-6 max-[560px]:mb-6 max-[560px]:flex-col max-[560px]:items-start max-[560px]:gap-3">
            <div>
              <p className="text-[0.78rem] tracking-[0.22em] text-brand-muted uppercase">
                {copy.catalog.label}
              </p>
              <h2 className="mt-[5px] font-serif text-[clamp(2.2rem,4vw,3.4rem)] leading-none">
                {copy.catalog.title}
              </h2>
            </div>

            <Link
              to="/shop"
              className="border-b border-brand-line pb-1 text-[0.82rem] tracking-[0.12em] text-brand-muted uppercase transition-colors hover:border-gold hover:text-cream"
            >
              {storeCopy.shop.viewAll}
            </Link>
          </div>

          <ProductGrid products={featured} isPending={isPending} isError={isError} />
        </div>
      </section>

      <TrustStrip />
    </main>
  );
}

export function HomePage() {
  return (
    <StorefrontShell floatingHeader>
      <HomeContent />
    </StorefrontShell>
  );
}
